// extracted by mini-css-extract-plugin
export default {"container":"vN-z","dimension":"wN-z","dimensionLabels":"xN-z"};